import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../../../core';
import { RepresentanteClassificacaoCliente } from '../representante-classificacao-cliente';

@Injectable({
    providedIn: 'root'
})
export class RepresentanteClassificacaoClienteHttpService {
    private pathApi: string;

    constructor(private customHttp: CustomHttp,
                private configServerService: ConfigServerService) {
        this.pathApi = `${this.configServerService.getPathApi()}/representante`
    }

    /** Pesquisa todos as Classificações de clientes vinculadas ao representante informado */
    search(idRepresentante: number): Observable<RepresentanteClassificacaoCliente[]> {
        return this.customHttp.get<RepresentanteClassificacaoCliente[]>(`${this.pathApi}/${idRepresentante}/classificacaocliente`);
    }
}
